import React, { useEffect, useState, useRef } from 'react';
import './Cursor.css';

const Cursor = () => {
    const cursorRef = useRef(null);
    const followerRef = useRef(null);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        const moveCursor = (e) => {
            const { clientX: x, clientY: y } = e;

            // Main dot follows instantly
            if (cursorRef.current) {
                cursorRef.current.style.transform = `translate3d(${x}px, ${y}px, 0)`;
            }

            // Follower has a slight delay/elasticity
            if (followerRef.current) {
                followerRef.current.animate({
                    transform: `translate3d(${x}px, ${y}px, 0)`
                }, {
                    duration: 500,
                    fill: "forwards",
                    easing: "ease-out"
                });
            }
        };

        const handleMouseOver = (e) => {
            if (e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.closest('button')) {
                setHovered(true);
            } else {
                setHovered(false);
            }
        };

        window.addEventListener('mousemove', moveCursor);
        window.addEventListener('mouseover', handleMouseOver);

        return () => {
            window.removeEventListener('mousemove', moveCursor);
            window.removeEventListener('mouseover', handleMouseOver);
        };
    }, []);

    return (
        <>
            <div ref={cursorRef} className={`custom-cursor-dot ${hovered ? 'hovered' : ''}`} />
            <div ref={followerRef} className={`custom-cursor-follower ${hovered ? 'hovered' : ''}`} />
        </>
    );
};

export default Cursor;
